// extracted by mini-css-extract-plugin
export var text = "_bk-0";